// 고객용 账单(청구서) 표 데이터 — 견적서 모달 행(quotationGroupItemsProcessed)에서 «고객에게 보여도 되는 값만» 뽑는다.
// 원가·할인율·선택ID·물류비·공통배분·未改价 는 여기서 아예 버린다 → 고객 그림 컴포넌트는 이 결과만 받는다(崔凡 확정 10-13).
// 금액은 견적서 모달 합계 행과 같은 값(행의 _부가세·_최종금액_KRW 합)을 그대로 쓴다 — 새로 계산하지 않는다.

// 고객 본인 정보인 헤더 항목(崔凡 확정 10-13). 이 목록 밖의 값은 버린다.
const HEADER_KEYS = ['화주주문번호', '상호', '화주명', '통관방식', '적용환율', '요청일', '사업자등록번호', '대표자명', '이메일'];

// 협상후 합계 — 견적서 모달 셀과 같은 우선순위(없으면 null → 화면에 '-')
function postTotalOf(r) {
  if (r._협상후_총금액_override != null) return r._협상후_총금액_override;
  if (r.주문정보 && r.주문정보.협상후_총금액 != null) return r.주문정보.협상후_총금액;
  if (r._未改价) return r._협상전_총금액;
  return null;
}

/**
 * @param {object[]} rows quotationGroupItemsProcessed
 * @param {string} customsType 'integrated' | 'kupass' | 'client' | 그 외(통관방법 문구)
 * @param {object} header 견적서 헤더 9항목(모달·PDF 와 같은 값) — 아래 HEADER_KEYS 만 받는다
 */
export function buildCustomerBill(rows, customsType, header) {
  // 같은 1688 주문은 붙여 놓는다(세로 병합은 이웃한 줄끼리만 된다). 주문번호 없는 줄은 병합하지 않는다.
  const order = [];
  const byKey = new Map();
  (rows || []).forEach((r, i) => {
    const oid = r._orderId && r._orderId !== 'unknown' ? r._orderId : null;
    const key = oid || ('solo-' + i);
    if (!byKey.has(key)) { byKey.set(key, []); order.push(key); }
    byKey.get(key).push(r);
  });
  const lines = [];
  order.forEach(key => {
    const g = byKey.get(key);
    const first = g[0];
    const postTotals = g.map(postTotalOf).filter(v => v != null);
    const sum = arr => Math.round(arr.reduce((s, v) => s + (Number(v) || 0), 0) * 100) / 100;
    g.forEach((r, idx) => {
      lines.push({
        name: r.상품명 || '',
        barcode: r.바코드 || '-',
        qty: r.구매요청수량 || 1,
        preUnit: r._협상전_단가,
        postUnit: r._협상후_단가 || null,
        // 묶음의 첫 줄에서만 값이 있고 span 만큼 세로로 합쳐 한 번만 보인다
        span: idx === 0 ? g.length : 0,
        preShip: idx === 0 ? (first._preOrderShipping || 0) : null,
        preTotal: idx === 0 ? sum(g.map(x => x._협상전_총금액)) : null,
        postShip: idx === 0 ? (first._postOrderShipping || 0) : null,
        postTotal: idx === 0 ? (postTotals.length ? sum(postTotals) : null) : null
      });
    });
  });
  const 최종 = (rows || []).reduce((s, r) => s + (r._최종금액_KRW || 0), 0);
  const 부가세 = (rows || []).reduce((s, r) => s + (r._부가세 || 0), 0);
  const integrated = customsType === 'integrated' || (customsType !== 'kupass' && customsType !== 'client' && String(customsType || '').includes('통합'));
  const h = {};
  HEADER_KEYS.forEach(k => { const v = header && header[k]; h[k] = v == null || v === '' ? '-' : String(v); });
  return {
    header: h,
    lines,
    integrated,
    totals: { 결제금액: 최종 - 부가세, 부가세, 최종금액: 최종 },
    // 물류비가 있으면 «별도 청구» 안내만 붙인다(금액은 넣지 않는다)
    hasLogistics: (rows || []).some(r => (r._중국물류비 || 0) + (r._공통배분 || 0) + (r._한국물류비 || 0) > 0)
  };
}
